import { FormattedMessage } from 'react-intl';
import { EditablePayerItem } from './EditablePayerItem';
import { FormSection } from '../FormSection';
import { FormElement } from '../FormElement';
import {
  OrganizationDTO,
  PayerDTO,
  useListPayersForTenant,
} from '@/api/trafikportalen';
import { useMemo } from 'react';

export const OrganizationPayers = ({
  organization,
}: {
  organization: OrganizationDTO;
}) => {
  const { data: payers } = useListPayersForTenant();

  const orgPayers = useMemo<PayerDTO[]>(() => {
    if (!payers) return [];
    return payers
      .filter((payer) => payer.organization_id === organization.id)
      .sort((a, b) => a.id.localeCompare(b.id));
  }, [payers, organization.id]);

  return (
    <FormSection title={<FormattedMessage defaultMessage="Fakturamottagare" />}>
      <p>
        <FormattedMessage defaultMessage="En fakturamottagare motsvarar en fakturamottagare i ert ekonomisystem. Det är organisationen själv som skapar fakturamottagare när de sätter unik betalningsinformation på en avdelning." />
      </p>
      <p>
        <FormattedMessage defaultMessage="Delar av informationen måste fyllas i av er själva, då denna kommer från ert ekonomisystem. Fylls den inte i kommer inte månadsavstämningen att fungera korrekt." />
      </p>
      <p>
        <FormattedMessage defaultMessage="Om organisationen är intern eller inte kan påverka vilka fält som krävs." />
      </p>

      <FormElement
        label={<FormattedMessage defaultMessage="Intern organisation" />}
        input={
          <p>
            {organization.is_internal ? (
              <FormattedMessage defaultMessage="Ja" />
            ) : (
              <FormattedMessage defaultMessage="Nej" />
            )}
          </p>
        }
      />
      <p>Antal: {orgPayers.length || 0}</p>
      {orgPayers?.map((payer) => (
        <EditablePayerItem key={payer.id} payer={payer} />
      ))}
    </FormSection>
  );
};
